import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from "react-i18next";

import { FormInput } from "../../../components/FormInput"
import { Controller, useForm } from "react-hook-form";

import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { checkDpSuccess, getLocale } from '../../../utility/service/tool-service';
import { queryCountyList } from '../../../utility/service/carbon-service';


export const BasicInfo = () => {
    const { t } = useTranslation();
    const [formRule, setFormRule] = useState([]);
    const [placeSetting, setPlaceSetting] = useState('addPlace');
    const [countyList, setCountyList] = useState([]);
    const axios_queryCountyList = () => {
        queryCountyList()
            .then((res) => {
                if (checkDpSuccess(res)) {
                    let data = res.data.RespBody.countyList;
                    setCountyList(data);
                }
            })
    }

    const zipCodeSeqTemplate = (option, props) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                    <div>
                        {option?.district}({option?.zipcode})
                    </div>
                </div>
            );
        }
        return <span>{props.placeholder}</span>;
    };
    const {
        control, handleSubmit, register, setValue, getValues,
        formState: { errors, isValid }
    } = useForm({
        defaultValues: {
            addressItems: [{ countyCode: '', zipcodeSeq: '', address: '' }]
        },
        //錯誤驗證時機
        mode: "all"
    })
    const setValidForm = useCallback((formId) => {
        if (formRule?.length > 0) {
            const tmp = formRule?.find((item) => {
                return Object.keys(item)[0] === formId
            });
            return tmp ? tmp[formId] : '';
        }
    }, [formRule]);

    const onSubmit = () => { }
    useEffect(() => {
        axios_queryCountyList();
    }, [])

    // const addressItems = watch('items', [{ countyCode: '', zipcodeSeq: '', address: '' }]);

    const addAddressList = () => {
        const currentItems = getValues('addressItems');
        setValue('addressItems', [...currentItems, { countyCode: '', zipcodeSeq: '', address: '' }]);
    }
    // const handleChange = (index, event) => {
    //     const newItems = [...addressItems];
    //     newItems[index].value = event.target.value;
    //     setAddressItems(newItems);
    // };
    const removedAddressItem = (index) => {
        const currentItems = getValues('addressItems');
        const newItems = currentItems.filter((_, i) => i !== index);
        setValue('addressItems', newItems);
    };

    return (
        <>
            <form className="grid" onSubmit={handleSubmit(onSubmit)}>
                {/* 廠商/公司名稱 */}
                <div className="col-12 lg:col-4">
                    <FormInput
                        register={register}
                        errors={errors}
                        id="keyword"
                        name="keyword"
                        type="text"
                        labelText="廠商/公司名稱"
                        labelClass="required"
                    />
                </div>
                {/* 聯絡人姓名 */}
                <div className="col-12 lg:col-4">
                    <FormInput
                        register={register}
                        errors={errors}
                        id="keyword"
                        name="keyword"
                        type="text"
                        labelText="聯絡人姓名"
                        labelClass="required"
                    />
                </div>
                {/* 電子信箱 */}
                <div className="col-12 lg:col-4">
                    <FormInput
                        register={register}
                        errors={errors}
                        id="keyword"
                        name="keyword"
                        type="text"
                        labelText="電子信箱"
                        labelClass="required"
                    />
                </div>
                {/* 電話 */}
                <div className="col-12 lg:col-4">
                    <FormInput
                        register={register}
                        errors={errors}
                        id="keyword"
                        name="keyword"
                        type="text"
                        labelText="電話"
                        labelClass="required"
                    />
                </div>
                {/* 數據盤查起迄時間 */}
                <div className="col-12 lg:col-4">
                    <FormInput
                        register={register}
                        errors={errors}
                        id="keyword"
                        name="keyword"
                        type="text"
                        labelText="數據盤查起迄時間"
                        labelClass="required"
                    />
                </div>
                {/* 標的產品製造地址 */}
                <div className="col-12">
                    <label
                        htmlFor="countyCode"
                        className="form-label required">
                        標的產品製造地址
                    </label>
                    <div className="flex align-items-start gap-2 flex-wrap">
                        {getValues('addressItems').map((item, index) => (
                            <div key={index} className="flex align-items-start gap-2 flex-wrap lg:flex-nowrap w-10">
                                {/* 中文(台灣) 才顯示縣市區可選 */}
                                {getLocale() === 'ZH-TW' && (
                                    <>
                                        <Controller
                                            name={`addressItems.${index}.countyCode`}
                                            control={control}
                                            rules={{ required: { value: true, message: t('validation.required') } }}
                                            render={({ field, fieldState }) => (
                                                <Dropdown
                                                    {...field}
                                                    filter
                                                    appendTo={"self"}
                                                    optionLabel="countyName"
                                                    optionValue="countyCode"
                                                    value={field.value}
                                                    virtualScrollerOptions={{ itemSize: 40 }}
                                                    defaultValue={""}
                                                    placeholder={t("plz_chs")}
                                                    name="countyCode"
                                                    control={control}
                                                    options={countyList}
                                                    className={`lg:w-3 w-full ` + classNames({ "p-invalid": fieldState.error })}
                                                    onChange={(event) => {
                                                        field.onChange(event.value);
                                                        setValue(`addressItems.${index}.zipcodeSeq`, "")
                                                    }}
                                                />
                                            )}
                                        />
                                        <Controller
                                            name={`addressItems.${index}.zipcodeSeq`}
                                            control={control}
                                            rules={setValidForm('zipcodeSeq')}
                                            render={({ field, fieldState }) => (
                                                <Dropdown
                                                    {...field}
                                                    filter
                                                    filterBy="district,zipcode"
                                                    // disabled={placeSetting === "place" || action === 'detail'}
                                                    appendTo={"self"}
                                                    optionLabel="district"
                                                    itemTemplate={zipCodeSeqTemplate}
                                                    valueTemplate={zipCodeSeqTemplate}
                                                    optionValue="zipcodeSeq"
                                                    value={field.value}
                                                    virtualScrollerOptions={{ itemSize: 40 }}
                                                    defaultValue={""}
                                                    placeholder={t("plz_chs")}
                                                    name="zipcodeSeq"
                                                    control={control}
                                                    options={countyList?.filter((item) => item.countyCode === getValues("countyCode"))[0]?.districList}
                                                    className={`lg:w-3 w-full ` + classNames({ "p-invalid": fieldState.error })}
                                                    onChange={(event) => {
                                                        field.onChange(event.value);
                                                    }}
                                                />
                                            )}
                                        />
                                    </>
                                )}
                                <div className="custom-input w-5">
                                    <input
                                        className='p-inputtext p-component'
                                        type="text"
                                        {...register(`addressItems.${index}.address`)}
                                        placeholder="輸入地址"
                                    />
                                </div>
                                {getValues('addressItems').length > 1 && (
                                    <Button className='p-button-icon-only'
                                        rounded text
                                        icon="pi pi-minus"
                                        onClick={() => removedAddressItem(index)}
                                    ></Button>
                                )}

                                {/* <FormInput
                                    // disabled={placeSetting === "place" || action === 'detail'}
                                    wrapperClass={`${getLocale()==='ZH-TW'?'lg:w-6 w-full':'col-12 w-full'}`}
                                    register={register}
                                    placeholder={t("validation.address")}
                                    errors={errors}
                                    id="address"
                                    name="address"
                                    type="text"
                                    rules={setValidForm("address")}
                                /> */}

                            </div>
                        ))}
                        <Button className='p-button-icon-only'
                            rounded text
                            icon="pi pi-plus"
                            onClick={addAddressList}
                        ></Button>
                    </div>
                    <small className='p-error block mt-2'>若有多個製造地點，請新增欄位</small>
                </div>

                <div className="col-12 lg:col-4">
                    <FormInput
                        register={register}
                        errors={errors}
                        id="keyword"
                        name="keyword"
                        type="text"
                        labelText="標的產品名稱"
                        labelClass="required"
                    />
                </div>
            </form>
        </>
    )
}